import { SupabaseClient } from "@supabase/supabase-js";
import { PRIVATE_AI_INSTANCE } from "../utils/config";

export const ENFORCE_STRIPE = false;

export async function getSubscription(
  supabase: SupabaseClient,
  user_id: string
) {
  const { data, error } = await supabase
    .from("subscriptions")
    .select()
    .eq("id", user_id)
    .single();

  return { data, error };
}

export async function checkSubscription(
  supabase: SupabaseClient,
  user_id: string
): Promise<boolean> {
  if (PRIVATE_AI_INSTANCE) {
    return true;
  } else {
    const { data, error } = await getSubscription(supabase, user_id);
    return data?.subscribed || false;
  }
}
